import React, { ChangeEvent, useState } from "react";
import { SketchPicker } from 'react-color';
import ControlFeedback from "./ControlFeedback";
import { ControlProps } from "./Types";

const SwitchControl: React.FC<ControlProps> = ({ name, value, width, validationResults, onChange, onBlur }) => {
    const [showPicker, setShowPicker] = useState<boolean>(false)

    function onControlChange(color: any) {
        onChange(color.hex);

        if (onBlur)
            onBlur();
    }

    let isValid = validationResults && validationResults.length > 0 ? false : true

    if (width === undefined)
        width = '100%';

    return (
        <div style={{ width: width }}>
            <div>
                <button type='button' onClick={() => setShowPicker(!showPicker)} style={{ backgroundColor: value, display: 'inline', width: 210 }} className='btn'>{value}&nbsp;</button>
            </div>
            {showPicker && <SketchPicker onChangeComplete={onControlChange} color={{ hex: value }} />}
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default SwitchControl;
